export const createActions = (data, voIds, sfx) => {
  if (!data || data.length === 0) {
    return [];
  }
  const results = [];
  data.forEach((a) => {
    const { type } = a;
    const act = createAction(type, a, voIds, sfx);
    if (act != null) {
      results.push(act);
    }
  });
  return results;
};

export const createAction = (type, data, voIds, sfx) => {
  switch (type) {
    case 'VO':
      data.voId = voIds[data.id];
      return voAction(data);
    case 'ANIM':
      return animAction(data);
    case 'EVT':
      return eventAction(data);
    case 'MOVE':
      return moveAction(data);
    case 'FOCUS':
      return focusAction(data);
    case 'FOREGROUND':
      return bringToTopAction(data);
    case 'SFX':
      data.sfx = { ...sfx[data.id] };
      return sfxAction(data);
    case 'SFX_STOP':
      data.sfx = { ...sfx[data.id] };
      return sfxStopAction(data);
    default:
      return false;
  }
};

const voAction = (data) => ({
  id: data.id,
  voId: data.voId,
  data,
  run(game, player) {
    player.playVO(data);
  },
});

const animAction = (data) => ({
  id: data.id,
  data,
  run(game, player) {
    player.playAnim(data);
  },
});

const eventAction = (data) => ({
  id: data.id,
  data,
  run(game, player) {
    player.playEvent(data);
  },
});

const moveAction = (data) => ({
  id: data.id,
  data,
  run(game, player) {
    player.playMove(data);
  },
});

const focusAction = (data) => ({
  id: data.id,
  data,
  run(game, player) {
    player.playFocus(data);
  },
});

const bringToTopAction = (data) => ({
  id: data.id,
  data,
  run(game, player) {
    player.playBringToTop(data);
  },
});

const sfxAction = (data) => ({
  id: data.id,
  sfx: data.sfx,
  data,
  run(game, player) {
    player.playSFX(data);
  },
});

const sfxStopAction = (data) => ({
  id: data.id,
  sfx: data.sfx,
  data,
  run(game, player) {
    player.stopSFX(data.sfx.id);
  },
});
